export enum ApiHeader {
    AppId = 'UL-App-Id',
    FallbackOrigin = 'UL-Fallback-Origin',
    Token = 'Authorization',
    TransactionId = 'UL-MFA-Transaction-Id',
    RequestId = 'AG-Request-Id', // Webgate won't overwrite request-id, hence classified as an ApiHeader
    AppVersion = 'AG-Initiator-Version',
}

export enum AgHeader {
    UserId = 'AG-User-Id',
    Origin = 'AG-Origin',
    Whitelabel = 'AG-WhiteLabel-Id',
    DeviceTypeId = 'AG-Device-Type-Id',
    LanguageId = 'AG-Language-Id',
    AnalyticsSessionId = 'AG-Analytics-Session-Id',
    BotInfo = 'AG-Bot-Info',
}

export enum DeviceIntelligenceHeader {
    BureauSessionId = 'AG-Vendor-SessionId',
    MangopayAttemptReferenceID = 'AG-Vendor-AttemptReference',
    FingerprintRequestId = 'AG-Vendor-RequestId',
    FingerprintVisitorId = 'Ag-Vendor-VisitorId',
    IncogniaRequestToken = 'AG-Vendor-RequestToken',
    SardineSessionKey = 'AG-Vendor-SessionKey',
    ForterToken = 'AG-Vendor-Token',
}

export enum CdnHeader {
    CnTunnel = 'AG-Cn-Tunnel',
}

export type Header = ApiHeader | AgHeader | DeviceIntelligenceHeader;

export type RequestHeader = {
    [header in Header]: string;
};
